import { fromJS } from 'immutable';
import { actionTypes } from '../../actions/AiAssistant/aiAssistantActions';

let defaultState = {
  showSidePanel: false,
  showSidePopup: false,
  loading: false,
  messages: [],
  streamingStatus: null,
  unreadCount: 0,
};

export default function aiAssistantReducer(state = fromJS(defaultState), action) {
  switch (action.type) {
    case actionTypes.AI_ASSISTANT__SHOW_SIDE_PANEL:
      return state.set('showSidePanel', true);

    case actionTypes.AI_ASSISTANT__HIDE_SIDE_PANEL:
      return state.set('showSidePanel', false);

    case actionTypes.AI_ASSISTANT__SHOW_SIDE_POPUP:
      return state.set('showSidePopup', true).set('unreadCount', 0);

    case actionTypes.AI_ASSISTANT__HIDE_SIDE_POPUP:
      return state.set('showSidePopup', false);

    case actionTypes.AI_ASSISTANT__ADD_MESSAGE:
      return state.update('messages', (messages) => messages.push(fromJS(action.payload)));

    case actionTypes.AI_ASSISTANT__SET_LOADING:
      return state.set('loading', action.payload);

    case actionTypes.AI_ASSISTANT__CLEAR_MESSAGES:
      return state.set('messages', fromJS([])).set('streamingStatus', null).set('unreadCount', 0);

    case actionTypes.AI_ASSISTANT__LOAD_MESSAGES: {
      const messages = action.payload || [];
      return state.set('messages', fromJS(messages));
    }

    case actionTypes.AI_ASSISTANT__START_STREAMING:
      return state.update('messages', (messages) =>
        messages.push(fromJS({
          id: action.payload.id,
          role: 'assistant',
          text: '',
          timestamp: action.payload.timestamp,
          streaming: true,
        }))
      );

    case actionTypes.AI_ASSISTANT__APPEND_CHUNK: {
      const lastIdx = state.get('messages').size - 1;
      return state
        .updateIn(['messages', lastIdx, 'text'], (text) => (text || '') + action.payload)
        // .set('streamingStatus', null);
    }

    case actionTypes.AI_ASSISTANT__FINISH_STREAMING: {
      const lastIdx = state.get('messages').size - 1;
      const isPopupClosed = !state.get('showSidePopup');
      return state
        .setIn(['messages', lastIdx, 'streaming'], false)
        .set('streamingStatus', null)
        .update('unreadCount', (n) => isPopupClosed ? n + 1 : n);
    }

    case actionTypes.AI_ASSISTANT__SET_STATUS:
      return state.set('streamingStatus', action.payload);

    default:
      return state;
  }
}
